<template>
    <div class="internal">

        <header-view
            :titulo="titulo"
            :breadcrumbs="true"
            :categories="categories"
            :category="category">
        </header-view>

        <div class="container">

            <div class="row">

                <!-- Single Commerce -->
                <div class="single-commerce">
                    <div class="col-sm-12">
                        <pulse-loader :loading="loading" class="text-center"></pulse-loader>

                        <div class="row" v-if="status">
                            <div class="col-md-5">
                                <figure class="internal-logo">
                                    <img :src="client.image" class="img-responsive" alt="">
                                </figure>
                            </div>
                            <div class="col-md-7">

                                <div class="infos">
                                    <div class="intro-infos">
                                        <h1>{{(client.name !== '') ? client.name : client.trade_name}}</h1>
                                    </div>



                                    <div class="details-infos">

                                        <div class="row" v-if="client.address">

                                            <div class="col-xs-2">
                                                <span class="fa fa-map-marker icon" aria-hidden="true"></span>
                                            </div>
                                            <div class="col-xs-10">
                                                <p>{{client.address}}<span v-if="client.address_number">, {{client.address_number}}</span><span v-if="client.address_complement"> - {{client.address_complement}}</span><br />
                                                {{client.city}} <span v-if="client.city && client.state">|</span> {{client.state}}</p>
                                            </div>

                                        </div>
                                        
                                        <div class="row" v-if="client.website">    

                                            <div class="col-xs-2">
                                                <span class="fa fa-external-link icon" aria-hidden="true"></span>
                                            </div>
                                            <div class="col-xs-10">
                                                <p><a :href="client.website" target="_blank">{{client.website}}</a></p>
                                            </div>

                                        </div>


                                        <div class="row" v-if="client.email">

                                            <div class="col-xs-2">
                                                <p><span class="fa fa-envelope-o icon" aria-hidden="true"></span></p>
                                            </div>
                                            <div class="col-xs-10">
                                                <p><a :href="'mailto:'+client.email" target="_blank">{{client.email}}</a></p>
                                            </div>

                                        </div>


                                        <div class="row" v-if="client.phone_number_1 || client.phone_number_2">

                                            <div class="col-xs-2">
                                                <span class="fa fa-phone icon" aria-hidden="true"></span>
                                            </div>
                                            <div class="col-xs-10">
                                                <p class="tel-area">
                                                    {{client.phone_number_1}} <span v-if="client.phone_number_1 && client.phone_number_2">/</span> {{client.phone_number_2}}
                                                </p>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                                <!-- End Infos -->

                            </div>

                            <div class="maps col-sm-12">

                              <h4 class="map-title">Mapa de Localização</h4>
                              
                              <div class="mapouter">
                                <div class="gmap_canvas">
                                  <iframe width="100%" height="300" id="gmap_canvas" :src="map_address" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                                </div>
                              </div>

                            </div>
                                                        
                        </div>
                    </div>
                </div>
                <!-- End Single Commerce -->

            </div>
        </div>
        <!-- / End Empresas -->

        <footer-view></footer-view>
    </div>
</template>

<script>
import HeaderView from './layout/Header'
import FooterView from './layout/Footer'
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import HTTP_Api from "../services/api.service";

export default {
  name: 'Empresa',
  props: {
  },
  components: {
    HeaderView,
    FooterView,
    PulseLoader
  },
  data: function () {
    return {
      titulo: 'Categoria',
      categories: [],
      clients: Object,
      category: '',
      loading: true,
      status: false,
      map_address: ''
    }
  },
  methods: {
    getEmpresa(pagenum) {
      this.loading = true;
      HTTP_Api.getClientData(pagenum)
        .then(response => {
          this.status = response.data.status;
          this.client = response.data.client;
          this.categories = response.data.categories;
          this.category = response.data.client.category;
          this.loading = false;
          //console.log('this.clients',this.clients)

          this.map_address = this.client.address + ',' + this.client.address_number + ' ' + this.client.city + ' ' + this.client.state
          this.map_address = 'https://maps.google.com/maps?q='+this.map_address+'&t=&z=15&ie=UTF8&iwloc=&output=embed&hl=pt-br'
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
  },
  created() {
    this.client_id = this.$route.params.client_id;
    HTTP_Api.setClientId(this.client_id)
    this.getEmpresa(1)
  },
  computed: {
    user () {
      return {
        displayName: '',
        avatar: '',
        roles: ['', '']
      }
    }
  }
}
</script>

<style>
.map-title {
  margin-bottom: 16px;
}
.mapouter{
  position:relative;
  text-align:right;
  height:300px;
  width:100%;
  margin-bottom: 20px;
}
.gmap_canvas {
  overflow:hidden;
  background:none!important;
  height:300px;
  width:100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Empresa.vue